import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Card, Stack, Link, Container, Typography, Button } from '@mui/material';
// components

import { PATH_AUTH } from '../../router/paths';
import LoginForm from '../../components/pages/authentication/LoginForm';
import Page from '../../components/common/Page';
import useResponsive from '../../hooks/useResponsive';
import GoogleLoginForm from '../../components/pages/authentication/GoogleLoginForm';
import FacebookLoginForm from '../../components/pages/authentication/FacebookLoginForm';
import Logo from '../../components/common/Logo';
// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  height: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(3, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
  const navigate = useNavigate();
  return (
    <RootStyle title="Login | Yiu's Villa">
      <Container maxWidth="sm">
        <ContentStyle>
          <Stack alignItems="center" justifyContent={'center'} sx={{ mb: 3 }}>
            <Logo
              sx={{
                width: '30vw',
                maxWidth: 450 / 3,
              }}
            />
            <Typography variant="h4" gutterBottom>
              Welcome to Yiu's Villa
            </Typography>
          </Stack>

          <LoginForm />
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
